import { render, staticRenderFns } from "./TransactionApproval.vue?vue&type=template&id=5ac1a84a&"
import script from "./TransactionApproval.vue?vue&type=script&lang=js&"
export * from "./TransactionApproval.vue?vue&type=script&lang=js&"
import style0 from "./TransactionApproval.vue?vue&type=style&index=0&id=5ac1a84a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports